export default "__VITE_PUBLIC_ASSET__16d8f31e__"